module.exports = __webpack_public_path__ + "static/snd-35271a1741cae1d9ed0071986c3acbe7.jpg";